import { IStorageService } from '../../services'

class StorageManager {
  private storageService: IStorageService

  constructor(storageService: IStorageService) {
    this.storageService = storageService
  }

  async upload(file: File) {
    if (!(file instanceof File)) {
      throw new Error('File is not a valid file')
    }

    const fileId = await this.storageService.upload(file)

    return fileId
  }
}

export default StorageManager
